export const BOOKKEEPER_ACCOUNT_TYPES = {
  ADMIN: 'ADMIN',
  INTERNAL: 'INTERNAL',
  TAX_EXPERT: 'TAX_EXPERT',
  STANDARD: 'STANDARD'
};

export const BOOKKEEPER_ASSIGNMENT_TYPES = {
  BLUE_DOT: 'BLUE_DOT',
  HOLD: 'HOLD',
  EXTENDED: 'EXTENDED'
};
